module.exports = __webpack_public_path__ + "img/kopsurat_eseme.c36bdcbd.png";